// --- Imports: Service Images ---
import tryon2d from "../assets/images/TryOnGrids/tryon2d.png";
import tryonvideo from "../assets/images/TryOnGrids/tryonvideo.png";
import styleadvisor from "../assets/images/TryOnGrids/styleadvisor.png";

// --- Imports: Blog Images ---
import blog1 from "../assets/images/Blogs/blog4.png";
import blog2 from "../assets/images/Blogs/blog5.png";
import blog3 from "../assets/images/Blogs/blog6.png";

// --- Imports: Product Images (Shoes) ---
import adidasgazelle from "../assets/images/Shoes/adidasgazelle.png";
import birkenstock from "../assets/images/Shoes/birkenstock.png";
import nikeairjordan1 from "../assets/images/Shoes/nikeairjordan1lowog.png";
import adizeroevosl from "../assets/images/Shoes/adizeroevosl.png";
import jordan4cement from "../assets/images/Shoes/jordan4cementwhite.png";
import sambaog from "../assets/images/Shoes/samba.png";
import airforce1 from "../assets/images/Shoes/af1.png";
import converse from "../assets/images/Shoes/converse.png";
import vansoldskool from "../assets/images/Shoes/vans.png";
import adizerosl2 from "../assets/images/Shoes/adizerosl2.png";
import polocourt from "../assets/images/Shoes/poloralphlaurencourt.png";
import supernovarise from "../assets/images/Shoes/adidassupernovarise.png";
import oncloudnova2 from "../assets/images/Shoes/oncloudnova2.png";
import rigorerarskate from "../assets/images/Shoes/rigorerarskate.png";
import drmartens from "../assets/images/Shoes/drmartens1461smoothleather.png";
import chucktaylorclean from "../assets/images/Shoes/chucktaylorallstarclean.png";
import nbaimeleon from "../assets/images/Shoes/newbalanceaimeleondore.png";
import jordan3pure from "../assets/images/Shoes/jordan3retropuremoney.png";
import timberland from "../assets/images/Shoes/timberland3eyelughandsewnboat.png";
import vansauthentic from "../assets/images/Shoes/vansclassicauthentic.png";
import vanssk8hi from "../assets/images/Shoes/vanssk8hihightop.png";
import dunkhigh from "../assets/images/Shoes/dunkhighretrocargokhaki.png";
import carrybarrette from "../assets/images/Shoes/carrybarrettecowhide.png";
import polovelvet from "../assets/images/Shoes/poloralphlaurencourt.png"; 
import horsebit from "../assets/images/Shoes/horsebitloafersdarkbrowncalf.png";
import leisurehandsewn from "../assets/images/Shoes/leisurehandsewn.png";
import seanlady from "../assets/images/Shoes/seanladywolfpenny.png";
import sambawales from "../assets/images/Shoes/sambawalesbonnersilver.png";
import guccibrixton from "../assets/images/Shoes/guccibrixtoncollapsibleheel.png";
import saintlaurent from "../assets/images/Shoes/saintlaurentwyattchelseaboots.png";
import wrangleryuma from "../assets/images/Shoes/wrangleryuma.png";
import eccoulttrn from "../assets/images/Shoes/eccoulttrn.png";
import nb993 from "../assets/images/Shoes/newbalance993madeinusa.png";
import acgmowabb from "../assets/images/Shoes/acgairmowabbrattanbirch.png";
import salomonodyssey from "../assets/images/Shoes/andwanderxsalomonodyssey1.png";
import asicskayano14 from "../assets/images/Shoes/asicsgelkayano14.png";
import salomonxt6gtx from "../assets/images/Shoes/salomonxt6goretex.png";
import salomonend from "../assets/images/Shoes/salomonxendxt6.png";
import nb530 from "../assets/images/Shoes/nb530.jpeg";
import bitis from "../assets/images/Shoes/bitishunterx.png";
import aj4oxidized from "../assets/images/Shoes/aj4retro.webp";
import asicsgel from "../assets/images/Shoes/asicsgel.webp";
import handballspezial from "../assets/images/Shoes/adidashandballspezial.avif";
import forumlow from "../assets/images/Shoes/adidasforumlow.avif";
import loaferGeneric from "../assets/images/Shoes/default.png";

// --- Imports: Style Images (MEN) ---
// Everyday
import m_casual1 from "../assets/images/Styles/Everyday-Casual/MEN/casual1.jpg";
import m_casual2 from "../assets/images/Styles/Everyday-Casual/MEN/casual2.png";
import m_casual3 from "../assets/images/Styles/Everyday-Casual/MEN/casual3.jpg";
import m_casual4 from "../assets/images/Styles/Everyday-Casual/MEN/casual4.jpg";
import m_casual5 from "../assets/images/Styles/Everyday-Casual/MEN/casual5.jpg";
import m_casual6 from "../assets/images/Styles/Everyday-Casual/MEN/casual6.jpg";
import m_casual7 from "../assets/images/Styles/Everyday-Casual/MEN/casual7.jpg";
import m_casual8 from "../assets/images/Styles/Everyday-Casual/MEN/casual8.png";
import m_casual9 from "../assets/images/Styles/Everyday-Casual/MEN/casual9.png";
import m_casual10 from "../assets/images/Styles/Everyday-Casual/MEN/casual10.jpg";
import m_casual11 from "../assets/images/Styles/Everyday-Casual/MEN/casual11.jpg";
import m_casual12 from "../assets/images/Styles/Everyday-Casual/MEN/casual12.jpg";
// Sport
import m_sport1 from "../assets/images/Styles/Active-Sporty/MEN/sport1.jpg";
import m_sport2 from "../assets/images/Styles/Active-Sporty/MEN/sport2.jpg";
import m_sport3 from "../assets/images/Styles/Active-Sporty/MEN/sport3.jpg";
import m_sport4 from "../assets/images/Styles/Active-Sporty/MEN/sport4.jpg";
import m_sport5 from "../assets/images/Styles/Active-Sporty/MEN/sport5.jpg";
import m_sport6 from "../assets/images/Styles/Active-Sporty/MEN/sport6.jpg";
import m_sport7 from "../assets/images/Styles/Active-Sporty/MEN/sport7.jpg";
// Formal
import m_formal1 from "../assets/images/Styles/Formal-Ceremony/MEN/formal1.jpg";
import m_formal2 from "../assets/images/Styles/Formal-Ceremony/MEN/formal2.jpg";
import m_formal3 from "../assets/images/Styles/Formal-Ceremony/MEN/formal3.jpg";
import m_formal4 from "../assets/images/Styles/Formal-Ceremony/MEN/formal4.jpg";
import m_formal5 from "../assets/images/Styles/Formal-Ceremony/MEN/formal5.jpg";
import m_formal6 from "../assets/images/Styles/Formal-Ceremony/MEN/formal6.jpg";
// Party
import m_party1 from "../assets/images/Styles/Party-Celebration/MEN/party1.jpg";
import m_party2 from "../assets/images/Styles/Party-Celebration/MEN/party2.jpg";
import m_party3 from "../assets/images/Styles/Party-Celebration/MEN/party3.jpg";
import m_party4 from "../assets/images/Styles/Party-Celebration/MEN/party4.jpg";
import m_party5 from "../assets/images/Styles/Party-Celebration/MEN/party5.jpg";
import m_party6 from "../assets/images/Styles/Party-Celebration/MEN/party6.jpg";
import m_party7 from "../assets/images/Styles/Party-Celebration/MEN/party7.jpg";
// Travel
import m_travel1 from "../assets/images/Styles/Travel/MEN/travel1.jpg";
import m_travel2 from "../assets/images/Styles/Travel/MEN/travel2.jpg";
import m_travel3 from "../assets/images/Styles/Travel/MEN/travel3.jpg";
import m_travel4 from "../assets/images/Styles/Travel/MEN/travel4.jpg";
import m_travel5 from "../assets/images/Styles/Travel/MEN/travel5.jpg";
import m_travel6 from "../assets/images/Styles/Travel/MEN/travel6.jpg";
import m_travel7 from "../assets/images/Styles/Travel/MEN/travel7.jpg";
import m_travel8 from "../assets/images/Styles/Travel/MEN/travel8.jpg";

// --- Imports: Style Images (WOMEN) ---
// Everyday
import w_casual1 from "../assets/images/Styles/Everyday-Casual/WOMEN/casual1.jpg";
import w_casual2 from "../assets/images/Styles/Everyday-Casual/WOMEN/casual2.jpg";
import w_casual3 from "../assets/images/Styles/Everyday-Casual/WOMEN/casual3.jpg";
// Sport
import w_sport1 from "../assets/images/Styles/Active-Sporty/WOMEN/sport1.jpg";
import w_sport2 from "../assets/images/Styles/Active-Sporty/WOMEN/sport2.jpg";
import w_sport3 from "../assets/images/Styles/Active-Sporty/WOMEN/sport3.jpg";
import w_sport4 from "../assets/images/Styles/Active-Sporty/WOMEN/sport4.jpg";
import w_sport5 from "../assets/images/Styles/Active-Sporty/WOMEN/sport5.jpg";
import w_sport6 from "../assets/images/Styles/Active-Sporty/WOMEN/sport6.jpg";


// --- EXPORT: Services ---
export const servicesData = [
  { id: 1, image: tryon2d, title: "Ảnh Thử Giày AI", link: "/tryon2d" },
  { id: 2, image: tryonvideo, title: "Video Thử Giày AI", link: "/tryonvideo" },
  { id: 3, image: styleadvisor, title: "Tư Vấn Phong Cách", link: "/styleadvisor" }
];

// --- EXPORT: Blogs ---
export const blogsData = [
  { id: 1, title: "Hot Picks for Holiday", author: "Kristin Watson", date: "09/11/2025", image: blog1, link: "/blog/1" },
  { id: 2, title: "Sneaker Drops of 2025", author: "Kyle Delaney", date: "12/02/2025", image: blog2, link: "/blog/2" },
  { id: 3, title: "Jordan 1 Guide", author: "Thomas Banner", date: "08/04/2024", image: blog3, link: "/blog/3" }
];

// --- EXPORT: Products ---
export const productsData = [
  {
    id: "adidasgazelle",
    title: "Adidas Gazelle",
    price: 2800000, // Thêm giá
    image: adidasgazelle,
    description: "Một mẫu giày cổ điển vượt thời gian từ kho lưu trữ của Adidas...",
    ai_description: "Sneaker cổ thấp, da lộn, logo ba sọc, lớp phủ chữ T mũi giày."
  },
  {
    id: "birkenstock",
    title: "Birkenstock Arizona",
    price: 3500000,
    image: birkenstock,
    description: "Mẫu sandal hai quai mang tính biểu tượng của Birkenstock...",
    ai_description: "Sandal hở mũi, hai quai rộng, khóa kim loại, lót gỗ bần."
  },
  {
    id: "nikeairjordan1lowog",
    title: "Nike Air Jordan 1 Low OG",
    price: 4200000,
    image: nikeairjordan1,
    description: "Phiên bản cổ thấp của đôi sneaker huyền thoại năm 1985...",
    ai_description: "Sneaker bóng rổ cổ thấp, thân da, lỗ thông hơi mũi giày, logo Swoosh."
  },
  {
    id: "adizeroevosl",
    title: "Adidas Adizero Evo SL",
    price: 3800000,
    image: adizeroevosl,
    description: "Giày chạy hiệu suất siêu nhẹ thiết kế cho các cuộc đua...",
    ai_description: "Giày chạy tối giản, thân lưới mỏng, đế giữa xốp nhẹ hình rocker."
  },
  {
    id: "jordan4cementwhite",
    title: "Air Jordan 4 Retro OG 'White Cement'",
    price: 5500000,
    image: jordan4cement,
    description: "Mẫu Jordan 4 Retro mang tính biểu tượng...",
    ai_description: "Cổ điển nhưng vượt thời gian. Hoàn hảo cho sưu tập và mang hàng ngày."
  },
  {
    id: "sambaog",
    title: "Adidas Samba OG 'White Black Gum'",
    price: 2500000,
    image: sambaog,
    description: "Mẫu giày cổ điển vượt thời gian của thời trang đường phố...",
    ai_description: "Thiết kế tối giản với nét quyến rũ cổ điển."
  },
  {
    id: "airforce1",
    title: "Nike Air Force 1 ’07 'Triple White'",
    price: 2900000,
    image: airforce1,
    description: "Đôi Air Force 1 Low được yêu thích mọi thời đại...",
    ai_description: "Linh hoạt và mang tính biểu tượng. Một đôi sneaker phải có."
  },
  {
    id: "conversehightop",
    title: "Converse Chuck Taylor All-Stars",
    price: 1800000,
    image: converse,
    description: "Đôi Converse cổ cao huyền thoại — linh hoạt, bền bỉ...",
    ai_description: "Thường ngày nhưng đầy biểu cảm. Hoàn hảo cho cá tính sáng tạo."
  },
  {
    id: "vansoldskool",
    title: "Vans Old Skool OG Black White",
    price: 1950000,
    image: vansoldskool,
    description: "Đôi giày trượt ván cổ thấp cổ điển có sọc sidestripe...",
    ai_description: "Giày cổ thấp da lộn/canvas đen, sọc trắng, đế waffle."
  },
  {
    id: "adizerosl2",
    title: "Adidas Adizero Sl2",
    price: 3200000,
    image: adizerosl2,
    description: "Giày chạy nhẹ thiết kế cho tốc độ và luyện tập hàng ngày.",
    ai_description: "Thân lưới nhẹ, ba sọc đặc trưng, đế xốp có đệm."
  },
  {
    id: "poloralphlaurencourt",
    title: "Polo Ralph Lauren Court VLC",
    price: 2400000,
    image: polocourt,
    description: "Sneaker lấy cảm hứng từ sân tennis cổ điển...",
    ai_description: "Sneaker cổ thấp canvas, logo Polo thêu, đế cao su trắng."
  },
  {
    id: "adidassupernovarise",
    title: "Adidas Supernova Rise",
    price: 3100000,
    image: supernovarise,
    description: "Giày luyện tập hàng ngày thoải mái với lớp đệm Dreamstrike+.",
    ai_description: "Thân lưới kỹ thuật, cổ giày đệm, đế giữa dày Dreamstrike+."
  },
  {
    id: "oncloudnova2",
    title: "On Cloudnova 2 All White",
    price: 4500000,
    image: oncloudnova2,
    description: "Sneaker mang cả ngày với lớp đệm CloudTec thế hệ mới.",
    ai_description: "Sneaker cổ thấp toàn trắng, cấu trúc tất, đế 'đám mây'."
  },
  {
    id: "rigorerarskate",
    title: "Rigorer AR Skate Shoes",
    price: 2100000,
    image: rigorerarskate,
    description: "Kiểu dáng gọn gàng, lấy cảm hứng từ giày trượt ván...",
    ai_description: "Thân giày da/tổng hợp toàn trắng, cổ thấp, đế lưu hóa phẳng."
  },
  {
    id: "drmartens1461smoothleather",
    title: "Dr. Martens 1461 Smooth Leather",
    price: 4800000,
    image: drmartens,
    description: "Đôi giày 3 lỗ xỏ dây unisex mang tính biểu tượng...",
    ai_description: "Giày cổ thấp da đen, 3 lỗ xỏ, chỉ vàng, đế đệm khí."
  },
  {
    id: "chucktaylorallstarclean",
    title: "Converse Chuck Taylor All Star Clean",
    price: 1900000,
    image: chucktaylorclean,
    description: "Phiên bản cao cấp, tối giản của đôi Chuck Taylor...",
    ai_description: "Kiểu dáng Chuck Taylor, thân canvas/da cao cấp, mũi cao su trắng."
  },
  {
    id: "newbalanceaimeleondore",
    title: "NB X AIMÉ LEON DORE 860V2",
    price: 6500000,
    image: nbaimeleon,
    description: "Giày chạy retro-tech được định nghĩa lại bởi Aimé Leon Dore.",
    ai_description: "Giày chạy cổ điển, lưới xanh dương, lớp phủ bạc/vàng, đế N-ergy."
  },
  {
    id: "jordan3retropuremoney",
    title: "Air Jordan 3 Retro 'Pure Money'",
    price: 5800000,
    image: jordan3pure,
    description: "Air Jordan 3 trong phối màu 'Pure Money' tinh khôi...",
    ai_description: "Bóng rổ cổ trung, da sần trắng, họa tiết da voi xám nhạt."
  },
  {
    id: "timberland3eyelughandsewnboat",
    title: "Timberland 3-Eye Lug Handsewn",
    price: 3900000,
    image: timberland,
    description: "Thân giày boat shoe may thủ công kết hợp đế lug chắc chắn.",
    ai_description: "Da full-grain nâu, moc-toe, dây da 360 độ, đế lug dày."
  },
  {
    id: "vansclassicauthentic",
    title: "Vans Classic Authentic Red",
    price: 1600000,
    image: vansauthentic,
    description: "Đôi giày di sản nguyên bản của Vans với thân vải canvas đỏ.",
    ai_description: "Cổ thấp canvas đỏ, lỗ xỏ kim loại, đế waffle nâu."
  },
  {
    id: "vanssk8hihightop",
    title: "Vans Classic SK8-HI",
    price: 2100000,
    image: vanssk8hi,
    description: "Giày trượt ván cổ cao huyền thoại với thân da lộn/canvas.",
    ai_description: "Cổ cao da lộn/canvas đen, sọc trắng, cổ đệm, đế waffle."
  },
  {
    id: "dunkhighretrocargokhaki",
    title: "Nike Dunk High Retro 'Cargo Khaki'",
    price: 3400000,
    image: dunkhigh,
    description: "Biểu tượng bóng rổ thập niên 80 với giao diện hai tông màu...",
    ai_description: "Cổ cao da trắng, lớp phủ xanh ô liu, logo Swoosh khaki."
  },
  {
    id: "carrybarrettecowhide",
    title: "Carry Barrette Cowhide Loafer",
    price: 2800000,
    image: carrybarrette,
    description: "Loafer vượt thời gian chế tác từ da bò thật...",
    ai_description: "Loafer da bò mịn, quai ngang barrette, gót thấp."
  },
  {
    id: "polovelvet",
    title: "Polo Ralph Lauren Velvet Loafer",
    price: 3200000,
    image: polovelvet,
    description: "Giày lười thanh lịch từ vải nhung sang trọng...",
    ai_description: "Thân nhung, logo Polo thêu, lót satin, gót thấp."
  },
  {
    id: "horsebitloafersdarkbrowncalf",
    title: "Horsebit Loafers Dark Brown",
    price: 4100000,
    image: horsebit,
    description: "Loafer da bê màu nâu sẫm với chi tiết kim loại horsebit.",
    ai_description: "Da bê nâu sẫm, horsebit kim loại, moc-toe, gót thấp."
  },
  {
    id: "leisurehandsewn",
    title: "Leisure Handsewn Color 8",
    price: 5200000,
    image: leisurehandsewn,
    description: "Penny loafer may thủ công từ da Shell Cordovan...",
    ai_description: "Da shell cordovan đỏ đậm, moc-toe, quai penny, đế da."
  },
  {
    id: "seanladywolfpenny",
    title: "The Sean Lady Wolf Penny Loafer",
    price: 3600000,
    image: seanlady,
    description: "Penny loafer hai tông màu hiện đại (nâu và trắng ngà).",
    ai_description: "Da hai tông màu, quai penny, đế lug hầm hố."
  },
  {
    id: "sambawalesbonnersilver",
    title: "Adidas Samba Wales Bonner Silver",
    price: 6800000,
    image: sambawales,
    description: "Samba hợp tác với Wales Bonner, màu bạc kim loại...",
    ai_description: "Da bạc kim loại, ba sọc móc, lưỡi gà gập dài, đế gôm."
  },
  {
    id: "guccibrixtoncollapsibleheel",
    title: "Gucci Brixton Loafer",
    price: 18500000,
    image: guccibrixton,
    description: "Loafer horsebit của Gucci với gót có thể gập lại.",
    ai_description: "Da mịn, horsebit vàng, gót mềm có thể đạp gót."
  },
  {
    id: "saintlaurentwyattchelseaboots",
    title: "Saint Laurent Wyatt Chelsea Boots",
    price: 22000000,
    image: saintlaurent,
    description: "Chelsea boot mang tính biểu tượng của YSL bằng da lộn nâu.",
    ai_description: "Chelsea boot da lộn, thun hông, mũi hạnh nhân, gót Cuban."
  },
  {
    id: "wrangleryuma",
    title: "Wrangler Yuma Combat Boots",
    price: 2700000,
    image: wrangleryuma,
    description: "Combat boot nam chắc chắn của Wrangler bằng da bền bỉ.",
    ai_description: "Combat boot da, buộc dây, cổ đệm, đế lug cao su."
  },
  {
    id: "eccoulttrn",
    title: "ECCO Ult-Trn",
    price: 4900000,
    image: eccoulttrn,
    description: "Giày leo núi nhẹ hiện đại với công nghệ thoải mái của ECCO.",
    ai_description: "Giày leo núi tổng hợp/dệt, đế PHORENE, đế ngoài Michelin."
  },
  {
    id: "newbalance993madeinusa",
    title: "New Balance 993 Made in USA",
    price: 5900000,
    image: nb993,
    description: "Giày chạy 'Made in USA' pha trộn da lộn và lưới cao cấp.",
    ai_description: "Da lộn xám, lưới xám, logo N phản quang, đế ABZORB."
  },
  {
    id: "acgairmowabbrattanbirch",
    title: "Nike ACG Air Mowabb",
    price: 4200000,
    image: acgmowabb,
    description: "Giày leo núi ACG với lót neoprene và thân nubuck.",
    ai_description: "Nubuck rám nắng, lót neoprene xanh/cam, hỗ trợ gót Huarache."
  },
  {
    id: "andwanderxsalomonodyssey1",
    title: "And Wander x Salomon Odyssey 1",
    price: 7200000,
    image: salomonodyssey,
    description: "Giày leo núi đường dài Salomon tái hiện bởi And Wander.",
    ai_description: "Tổng hợp kỹ thuật, lớp phủ hàn nhiệt, Quicklace, đế đệm cao."
  },
  {
    id: "asicsgelkayano14",
    title: "Asics Gel-Kayano 14",
    price: 3800000,
    image: asicskayano14,
    description: "Giày chạy retro-tech thập niên 2000 với nền lưới đen.",
    ai_description: "Lưới đen, lớp phủ bạc/xám, đế GEL có thể nhìn thấy."
  },
  {
    id: "salomonxt6gtx",
    title: "Salomon XT-6 Gore-Tex",
    price: 5600000,
    image: salomonxt6gtx,
    description: "Giày chạy đường mòn XT-6 cập nhật màng chống nước Gore-Tex.",
    ai_description: "Thân chống nước đen, GORE-TEX, Quicklace, đế ACS."
  },
  {
    id: "salomonxendxt6",
    title: "Salomon x END. XT-6 'Porcini'",
    price: 6200000,
    image: salomonend,
    description: "Hợp tác END. trên mẫu XT-6, lấy cảm hứng từ nấm Porcini.",
    ai_description: "Lưới tông màu đất (be/nâu), Quicklace, đế ACS."
  },
  {
    id: "nb530",
    title: "New Balance 530",
    price: 2500000,
    image: nb530,
    description: "Giày chạy cổ điển thập niên 2000 với lưới trắng và xanh navy.",
    ai_description: "Lưới trắng, lớp phủ bạc/xanh, đế ABZORB."
  },
  {
    id: "bitishunterx",
    title: "Biti's Hunter X White",
    price: 1200000,
    image: bitis,
    description: "Sneaker phong cách sống từ Biti's, phiên bản toàn trắng.",
    ai_description: "Vải dệt kim/lưới trắng, cấu trúc tất, đế xốp nhẹ."
  },
  {
    id: "aj4retro",
    title: "Air Jordan 4 Retro 'Oxidized Green'",
    price: 5900000,
    image: aj4oxidized,
    description: "AJ4 da trắng cao cấp với điểm nhấn 'Oxidized Green'.",
    ai_description: "Da trắng, lưới trắng, lỗ xỏ/đế xanh lá kim loại, đệm Air."
  },
  {
    id: "asicsgel",
    title: "ASICS GEL-KAYANO 14",
    price: 3800000,
    image: asicsgel,
    description: "Giày chạy retro-tech thập niên 2000, thẩm mỹ nhiều lớp.",
    ai_description: "Lưới nhiều lớp trắng/bạc, lớp phủ kim loại, đệm GEL."
  },
  {
    id: "adidashandballspezial",
    title: "Adidas Handball Spezial",
    price: 2900000,
    image: handballspezial,
    description: "Giày bóng ném cổ điển thập niên 70, thân da lộn cao cấp.",
    ai_description: "Da lộn, ba sọc tương phản, đế cao su gôm tối màu."
  },
  {
    id: "adidasforumlow",
    title: "Adidas Forum Low",
    price: 2600000,
    image: forumlow,
    description: "Giày bóng rổ thập niên 80 cổ thấp với quai dán đặc trưng.",
    ai_description: "Thân da, mũi đục lỗ, quai velcro, đế cupsole."
  }
];

// --- EXPORT: Style Data (Outfits) ---
export const styleData = {
  MEN: {
    everyday: [
      { src: m_casual1, shoeId: "loafer" },
      { src: m_casual2, shoeId: "drmartens1461smoothleather" },
      { src: m_casual3, shoeId: "chucktaylorallstarclean" },
      { src: m_casual4, shoeId: "sambaog" },
      { src: m_casual5, shoeId: "newbalanceaimeleondore" },
      { src: m_casual6, shoeId: "jordan3retropuremoney" },
      { src: m_casual7, shoeId: "sambaog" },
      { src: m_casual8, shoeId: "sambaog" },
      { src: m_casual9, shoeId: "timberland3eyelughandsewnboat" },
      { src: m_casual10, shoeId: "vansclassicauthentic" },
      { src: m_casual11, shoeId: "vanssk8hihightop" },
      { src: m_casual12, shoeId: "dunkhighretrocargokhaki" }
    ],
    sport: [
      { src: m_sport1, shoeId: "adizerosl2" },
      { src: m_sport2, shoeId: "poloralphlaurencourt" },
      { src: m_sport3, shoeId: "adizeroevosl" },
      { src: m_sport4, shoeId: "hokabondi8" }, 
      { src: m_sport5, shoeId: "adidassupernovarise" },
      { src: m_sport6, shoeId: "oncloudnova2" },
      { src: m_sport7, shoeId: "rigorerarskate" }
    ],
    formal: [
      { src: m_formal1, shoeId: "carrybarrettecowhide" },
      { src: m_formal2, shoeId: "poloralphlaurencourt" },
      { src: m_formal3, shoeId: "loafer" },
      { src: m_formal4, shoeId: "horsebitloafersdarkbrowncalf" },
      { src: m_formal5, shoeId: "loafer" },
      { src: m_formal6, shoeId: "leisurehandsewn" }
    ],
    party: [
      { src: m_party1, shoeId: "seanladywolfpenny" },
      { src: m_party2, shoeId: "loafer" },
      { src: m_party3, shoeId: "sambawalesbonnersilver" },
      { src: m_party4, shoeId: "guccibrixtoncollapsibleheel" },
      { src: m_party5, shoeId: "saintlaurentwyattchelseaboots" },
      { src: m_party6, shoeId: "loafer" },
      { src: m_party7, shoeId: "loafer" }
    ],
    travel: [
      { src: m_travel1, shoeId: "wrangleryuma" },
      { src: m_travel2, shoeId: "eccoulttrn" },
      { src: m_travel3, shoeId: "newbalance993madeinusa" },
      { src: m_travel4, shoeId: "acgairmowabbrattanbirch" },
      { src: m_travel5, shoeId: "andwanderxsalomonodyssey1" },
      { src: m_travel6, shoeId: "asicsgelkayano14" },
      { src: m_travel7, shoeId: "salomonxt6goretex" },
      { src: m_travel8, shoeId: "salomonxendxt6" }
    ]
  },
  WOMEN: {
    everyday: [
      { src: w_casual1, shoeId: "adidashandballspezial" },
      { src: w_casual2, shoeId: "sambaog" },
      { src: w_casual3, shoeId: "adidasforumlow" }
    ],
    sport: [
      { src: w_sport1, shoeId: "hokabondi8" },
      { src: w_sport2, shoeId: "nb530" },
      { src: w_sport3, shoeId: "nb530" },
      { src: w_sport4, shoeId: "bitishunterx" },
      { src: w_sport5, shoeId: "aj4retro" },
      { src: w_sport6, shoeId: "asicsgel" }
    ]
  }
};

// --- EXPORT: Shoe Data (Supplementary) ---
export const shoeData = {
  "loafer": {
    src: loaferGeneric,
    name: "Classic Brown Loafer"
  }
};